var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 106,
    viewBox: "0 0 217 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 205.129,
    height: 65.7521,
    transform: "matrix(1 -6.75821e-08 -1.13088e-07 -1 4.87744 94.9204)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 186.477,
    height: 10.9208,
    transform: "matrix(1 -6.75821e-08 -1.13088e-07 -1 15.9442 101.732)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 10.9208,
    transform: "matrix(1 -6.75821e-08 -1.13088e-07 -1 11.4312 100.67)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 10.9208,
    transform: "matrix(1 -6.75821e-08 -1.13088e-07 -1 9.19434 97.2725)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 14.1179,
    transform: "matrix(1 -8.73668e-08 -8.74787e-08 -1 7.23206 41.5942)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 18.7712,
    transform: "matrix(1 -8.73668e-08 -8.74787e-08 -1 33.3687 24.5986)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 18.7712,
    transform: "matrix(1 -8.73668e-08 -8.74787e-08 -1 38.5972 28.9131)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 18.7712,
    transform: "matrix(1 -8.73668e-08 -8.74787e-08 -1 43.1102 36.8628)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 10.9208,
    transform: "matrix(1 -6.75821e-08 -1.13088e-07 -1 199.631 97.333)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 7.80055,
    height: 14.1179,
    transform: "matrix(1 -8.73668e-08 -8.74787e-08 -1 197.889 38.6533)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 187.587,
    height: 14.1179,
    transform: "matrix(1 -8.73668e-08 -8.74787e-08 -1 13.5896 35.9087)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7234 22.3003L31.4065 22.3003L31.4065 4.96553L35.7234 4.96553L35.7234 22.3003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0402 4.96533L35.7234 4.96533L35.7234 0.65125L40.0402 0.65125L40.0402 4.96533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4355 9.35742L40.1187 9.35742L40.1187 5.04334L44.4355 5.04334L44.4355 9.35742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7524 13.6714L44.4355 13.6714L44.4355 9.3573L48.7524 9.3573L48.7524 13.6714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0693 17.9858L48.7524 17.9858L48.7524 13.6718L53.0693 13.6718L53.0693 17.9858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4647 22.3003L53.1478 22.3003L53.1478 17.9862L57.4647 17.9862L57.4647 22.3003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.532 22.3003L53.1478 22.3003L53.1478 17.9862L203.532 17.9862L203.532 22.3003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7233 22.3003L15.9442 22.3003L15.9442 17.9862L35.7233 17.9862L35.7233 22.3003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.531 104.867L15.9443 104.867L15.9443 100.553L203.531 100.553L203.531 104.867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.561 92.0405L212.244 92.0405L212.244 31.0071L216.561 31.0071L216.561 92.0405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.848 100.553L203.531 100.553L203.531 96.2387L207.848 96.2387L207.848 100.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.165 96.1602L207.848 96.1602L207.848 91.8461L212.165 91.8461L212.165 96.1602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.848 26.6924L203.531 26.6924L203.531 22.3783L207.848 22.3783L207.848 26.6924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.165 31.0063L207.848 31.0063L207.848 26.6923L212.165 26.6923L212.165 31.0063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23202 92.0405L2.91516 92.0405L2.91515 31.0071L7.23201 31.0071L7.23202 92.0405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9442 100.553L11.6273 100.553L11.6273 96.2387L15.9442 96.2387L15.9442 100.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5489 96.1602L7.23206 96.1602L7.23206 91.8461L11.5489 91.8461L11.5489 96.1602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9442 26.6924L11.6273 26.6924L11.6273 22.3783L15.9442 22.3783L15.9442 26.6924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5489 31.0063L7.23206 31.0063L7.23206 26.6923L11.5489 26.6923L11.5489 31.0063Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3687 23.084L29.0519 23.084L29.0519 5.74922L33.3687 5.74922L33.3687 23.084Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6856 5.74902L33.3687 5.74902L33.3687 1.43494L37.6856 1.43494L37.6856 5.74902Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0811 10.1421L37.7642 10.1421L37.7642 5.82801L42.0811 5.82801L42.0811 10.1421Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3977 14.4556L42.0809 14.4556L42.0809 10.1415L46.3977 10.1415L46.3977 14.4556Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7146 18.77L46.3978 18.77L46.3978 14.4559L50.7146 14.4559L50.7146 18.77Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1101 23.084L50.7932 23.084L50.7932 18.7699L55.1101 18.7699L55.1101 23.084Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.177 23.084L50.7932 23.084L50.7932 18.7699L201.177 18.7699L201.177 23.084Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3687 23.084L13.5896 23.084L13.5896 18.7699L33.3687 18.7699L33.3687 23.084Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.177 105.651L13.5896 105.651L13.5896 101.337L201.177 101.337L201.177 105.651Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.206 92.6304L209.889 92.6304L209.889 31.597L214.206 31.597L214.206 92.6304Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M205.494 101.337L201.177 101.337L201.177 97.0228L205.494 97.0228L205.494 101.337Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.81 96.9443L205.494 96.9443L205.494 92.6303L209.81 92.6303L209.81 96.9443Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.494 27.4775L201.177 27.4775L201.177 23.1635L205.494 23.1635L205.494 27.4775Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.811 31.7905L205.494 31.7905L205.494 27.4764L209.811 27.4764L209.811 31.7905Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87741 92.6309L0.560547 92.6309L0.56054 31.5975L4.8774 31.5975L4.87741 92.6309Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5896 101.337L9.27271 101.337L9.2727 97.0228L13.5896 97.0228L13.5896 101.337Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1943 96.9443L4.87744 96.9443L4.87744 92.6303L9.1943 92.6303L9.1943 96.9443Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5896 27.4775L9.27271 27.4775L9.2727 23.1635L13.5896 23.1635L13.5896 27.4775Z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1943 31.7905L4.87744 31.7905L4.87744 27.4764L9.1943 27.4764L9.1943 31.7905Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7712 54.6084V41.2751H26.3268V54.6084H21.8823V39.0528H35.2157V54.6084H30.7712ZM48.5403 43.4973V45.7195H50.7625V52.3862H48.5403V54.6084H41.8736V59.0528H37.4292V45.7195H39.6514V43.4973H48.5403ZM46.3181 45.7195H41.8736V52.3862H46.3181V45.7195ZM64.0872 43.4973V45.7195H66.3094V50.164H57.4205V52.3862H66.3094V54.6084H55.1983V52.3862H52.9761V45.7195H55.1983V43.4973H64.0872ZM61.865 45.7195H57.4205V47.9417H61.865V45.7195ZM68.5229 47.9417V45.7195H70.7452V43.4973H79.6341V45.7195H81.8563V47.9417H79.6341V50.164H81.8563V52.3862H79.6341V54.6084H70.7452V52.3862H68.5229V50.164H72.9674V52.3862H77.4118V50.164H75.1896V47.9417H77.4118V45.7195H72.9674V47.9417H68.5229ZM95.1809 43.4973V45.7195H97.4032V50.164H88.5143V52.3862H97.4032V54.6084H86.292V52.3862H84.0698V45.7195H86.292V43.4973H95.1809ZM92.9587 45.7195H88.5143V47.9417H92.9587V45.7195ZM108.506 54.6084V50.164H104.061V54.6084H99.6167V43.4973H104.061V47.9417H108.506V43.4973H112.95V54.6084H108.506ZM115.164 45.7195V43.4973H128.497V45.7195H124.052V54.6084H119.608V45.7195H115.164ZM135.155 52.3862H139.599V45.7195H135.155V52.3862ZM132.933 52.3862H130.71V45.7195H132.933V43.4973H144.044V54.6084H132.933V52.3862ZM146.257 54.6084V43.4973H150.702V52.3862H155.146V43.4973H159.591V56.8306H155.146V54.6084H146.257ZM166.249 52.3862V54.6084H161.804V43.4973H166.249V47.9417H168.471V45.7195H170.693V43.4973H175.138V54.6084H170.693V50.164H168.471V52.3862H166.249ZM179.573 47.9417H177.351V45.7195H179.573V43.4973H190.684V54.6084H186.24V50.164H181.796V54.6084H177.351V50.164H179.573V47.9417ZM186.24 47.9417V45.7195H181.796V47.9417H186.24Z",
    fill: "#444042"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7858 77.5744V80.6855H22.2302V72.9078H23.7858V76.0189H28.4524V72.9078H30.008V80.6855H28.4524V77.5744H23.7858ZM33.1237 79.13H31.5681V74.4633H33.1237V79.13ZM37.7903 76.0189H36.2348V74.4633H37.7903V72.9078H39.3459V80.6855H37.7903V79.13H36.2348V77.5744H37.7903V76.0189ZM36.2348 80.6855H33.1237V79.13H36.2348V80.6855ZM36.2348 74.4633H33.1237V72.9078H36.2348V74.4633ZM48.6838 79.13H47.1282V77.5744H48.6838V79.13ZM47.1282 72.9078V74.4633H42.4616V76.0189H47.1282V77.5744H42.4616V79.13H47.1282V80.6855H40.906V72.9078H47.1282ZM48.6838 76.0189H47.1282V74.4633H48.6838V76.0189ZM54.9106 79.13H53.355V77.5744H54.9106V79.13ZM58.0217 80.6855H56.4661V72.9078H58.0217V80.6855ZM51.7995 76.0189H53.355V77.5744H51.7995V79.13H53.355V80.6855H50.2439V72.9078H51.7995V76.0189ZM61.1373 77.5744V80.6855H59.5818V72.9078H61.1373V76.0189H64.2485V77.5744H61.1373ZM67.3596 80.6855H65.804V79.13H67.3596V80.6855ZM65.804 79.13H64.2485V77.5744H65.804V79.13ZM67.3596 74.4633H65.804V72.9078H67.3596V74.4633ZM65.804 76.0189H64.2485V74.4633H65.804V76.0189ZM75.1373 74.4633V80.6855H73.5818V72.9078H81.3596V80.6855H79.804V74.4633H75.1373ZM89.1419 74.4633H84.4752V72.9078H89.1419V74.4633ZM84.4752 80.6855V83.7967H82.9197V74.4633H84.4752V79.13H89.1419V80.6855H84.4752ZM90.6975 79.13H89.1419V74.4633H90.6975V79.13ZM98.4798 74.4633H93.8131V72.9078H98.4798V74.4633ZM93.8131 77.5744V79.13H92.2576V74.4633H93.8131V76.0189H98.4798V74.4633H100.035V77.5744H93.8131ZM100.035 80.6855H93.8131V79.13H100.035V80.6855ZM103.151 76.0189H101.595V74.4633H103.151V76.0189ZM107.818 74.4633H103.151V72.9078H107.818V74.4633ZM107.818 80.6855H103.151V79.13H107.818V80.6855ZM103.151 79.13H101.595V77.5744H103.151V79.13ZM107.818 77.5744H106.262V76.0189H107.818V77.5744ZM109.373 76.0189H107.818V74.4633H109.373V76.0189ZM109.373 79.13H107.818V77.5744H109.373V79.13ZM117.156 74.4633H112.489V72.9078H117.156V74.4633ZM112.489 77.5744V79.13H110.933V74.4633H112.489V76.0189H117.156V74.4633H118.711V77.5744H112.489ZM118.711 80.6855H112.489V79.13H118.711V80.6855ZM121.827 77.5744V80.6855H120.271V72.9078H121.827V76.0189H126.493V72.9078H128.049V80.6855H126.493V77.5744H121.827ZM134.276 74.4633V80.6855H132.72V74.4633H129.609V72.9078H137.387V74.4633H134.276ZM140.503 79.13H138.947V74.4633H140.503V79.13ZM145.169 76.0189H143.614V74.4633H145.169V72.9078H146.725V80.6855H145.169V79.13H143.614V77.5744H145.169V76.0189ZM143.614 80.6855H140.503V79.13H143.614V80.6855ZM143.614 74.4633H140.503V72.9078H143.614V74.4633ZM154.507 79.13V72.9078H156.063V82.2411H154.507V80.6855H148.285V72.9078H149.84V79.13H154.507ZM159.178 79.13V80.6855H157.623V72.9078H159.178V77.5744H160.734V79.13H159.178ZM163.845 74.4633V72.9078H165.401V80.6855H163.845V76.0189H162.289V74.4633H163.845ZM162.289 77.5744H160.734V76.0189H162.289V77.5744ZM168.516 79.13V80.6855H166.961V72.9078H168.516V77.5744H170.072V79.13H168.516ZM173.183 74.4633V72.9078H174.738V80.6855H173.183V76.0189H171.627V74.4633H173.183ZM171.627 77.5744H170.072V76.0189H171.627V77.5744Z",
    fill: "#1B1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresDesc);
export default __webpack_public_path__ + "static/media/presDesc.8cbe426fed6779e9d4ecd9bc88311ee8.svg";
export { ForwardRef as ReactComponent };